var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6961 20.6256C27.5613 22.1253 26.4753 24 24.7472 24H2.25254C0.521123 24 -0.559908 22.1224 0.303623 20.6256L11.5511 1.1243C12.4167 -0.376125 14.5848 -0.373406 15.4489 1.1243L26.6961 20.6256ZM13.5 16.5938C12.3091 16.5938 11.3438 17.5591 11.3438 18.75C11.3438 19.9409 12.3091 20.9062 13.5 20.9062C14.6909 20.9062 15.6563 19.9409 15.6563 18.75C15.6563 17.5591 14.6909 16.5938 13.5 16.5938ZM11.4528 8.84316L11.8006 15.2182C11.8168 15.5165 12.0635 15.75 12.3622 15.75H14.6378C14.9365 15.75 15.1832 15.5165 15.1995 15.2182L15.5472 8.84316C15.5648 8.52094 15.3082 8.25 14.9855 8.25H12.0144C11.6918 8.25 11.4353 8.52094 11.4528 8.84316Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.40f06dd87b32e06dfefb50a873d8a512.svg";
export { ForwardRef as ReactComponent };